<template>
  <section class="detail__item__ordered">
    <ul v-if="!isGlobalError && validateAccessToken && purchaseRecentDate">
      <li class="detail__item__ordered-detail"><span class="date">{{ this.purchaseRecentDate | formatDateString }}</span>にこの商品を注文しました。</li>
      <li class="detail__item__ordered-review lsf-icon comments"><a :href="reviewPostUrl">レビューを投稿する</a></li>
    </ul>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import urls from '@/mixins/urls'
import errors from '@/mixins/errors'
export default {
  name: 'BaseReviewEntryNotice',
  mixins: [ urls, errors ],
  computed: {
    ...mapGetters({
      purchaseRecentDate: 'storePurchase/purchaseRecentDate',
      itemAdditionalInfo: 'storeReviews/itemAdditionalInfo',
      targetSku: 'storePurchase/targetSku',
      cookies: 'commons/cookies'
    }),
    reviewPostUrl () {
      return this.getReviewPostUrl(this.targetSku, 'isDetail')
    }
  },
  methods: {
    ...mapActions({
      getPurchaseRecentDate: 'storePurchase/getPurchaseRecentDate',
      updateTargetSku: 'storePurchase/updateTargetSku'
    })
  },
  created () {
    // 初期表示
    if (this.validateAccessToken) {
      this.getPurchaseRecentDate().catch(error => {
        console.error(error.name)
      })
    }
    const that = this
    window.$(document).on('sku-change', function (event, params) {
      if (that.validateAccessToken) {
        that.updateTargetSku({
          targetSku: params.skuCode
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BaseReviewEntryNotice.vue